import { Input } from "@/components/ui/input";
import { FormField } from "@/components/forms/FormField";

const FIELDS = [
  ["first_name", "Nome", "text", "given-name"],
  ["last_name", "Cognome", "text", "family-name"],
  ["email", "Email", "email", "email"],
  ["phone", "Telefono", "tel", "tel"],
];

export const PersonFields = ({ value, onChange, errors = {}, prefix }) => (
  <div className="grid gap-4 sm:grid-cols-2">
    {FIELDS.map(([k, label, type, ac]) => (
      <FormField key={k} id={`${prefix}-${k}`} label={label} error={errors[k]}>
        <Input
          id={`${prefix}-${k}`}
          type={type}
          autoComplete={ac}
          inputMode={type === "tel" ? "tel" : undefined}
          placeholder={k === "phone" ? "+39 333 1234567" : undefined}
          className="h-12"
          value={value[k]}
          onChange={(e) => onChange({ ...value, [k]: e.target.value })}
          data-testid={`${prefix}-${k}-input`}
        />
      </FormField>
    ))}
  </div>
);
